import { render, staticRenderFns } from "./DormitoryLog.vue?vue&type=template&id=79e5d29c&"
import script from "./DormitoryLog.vue?vue&type=script&lang=js&"
export * from "./DormitoryLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports